<template>
	<div>
		<div class="doctorPage">
			<div class="centerHome centerHomeActive">
				<el-row class="ccHomec" :gutter="10" v-loading="loading">
					<el-col :span="patientInfoSpan" class="patientInfo" v-if="isNuclearMedicine">
						<patient-info @fold-change="handleFoldChange" />
					</el-col>
					<el-col :span="doctorReportSpan" class="doctorReport">
						<doctor-report />
					</el-col>
					<el-col :span="doctorGradeSpan" class="doctorGrade" v-if="isDoctor">
						<doctor-grade />
						<!-- <doctor-grade /> -->
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	import doctorReport from '@/components/doctorReport.vue'
	import doctorGrade from '@/components/doctorGrade.vue'
	import patientInfo from '@/components/patientInfo.vue'

	export default {
		data() {
			return {
				routers: '',
				componentKey: Math.random()*10,
				isDoctor: false,
				isPatientInfoFolded: false
			}
		},
		components: {
			doctorReport,
			doctorGrade,
			patientInfo
		},
		// watch: {
		// 	$route(to, from) {
		// 		// console.log(to.path.contain('scoring'));
		// 		// console.log(from.path.contain('scoring'));
		// 		//初始化
		// 		this.clearInit()
		// 		this.componentKey += 1;  
		// 	},
		// },
		computed: {
			...Vuex.mapState('breadcrumb',['loading']),
			...Vuex.mapState('doctor',['reportDetails']),
			elcolSpanValue() {
				if(this.isDoctor) {
					return 8
				}else{
					return 12
				}
			},
			isNuclearMedicine() {
				return this.reportDetails.Kind == 2
			},
			// 动态计算各个组件的宽度占比
			patientInfoSpan() {
				// 不是核医学直接为0，不渲染
				if (!this.isNuclearMedicine) return 0
				return this.isPatientInfoFolded ? 2 : 8
			},
			doctorReportSpan() {
				if (!this.isNuclearMedicine) {
					// 非核医学，doctorReport占据全部
					return this.isDoctor ? 12 : 24
				}
				if (this.isDoctor) {
					// 核医学+医生
					return this.isPatientInfoFolded ? 11 : 8
				} else {
					// 核医学+非医生
					return this.isPatientInfoFolded ? 22 : 16
				}
			},
			doctorGradeSpan() {
				if (!this.isNuclearMedicine) {
					// 非核医学，doctorGrade占据全部（如果显示）
					return this.isDoctor ? 12 : 0
				}
				if (this.isDoctor) {
					return this.isPatientInfoFolded ? 11 : 8
				} else {
					return 0
				}
			}
		},
		methods: {
			...Vuex.mapMutations('managerPlanList', ['clearInit']),
			// 处理patientInfo组件的折叠状态变化
			handleFoldChange(isFolded) {
				this.isPatientInfoFolded = isFolded
			}
		},
		activated() {
			this.isDoctor = true
		}

	}
</script>

<style scoped lang="scss">
@import '../../assets/style/variables.scss';
@import '../../assets/style/mixin.scss';

.doctorPage {
	.centerHome {
		.ccHomec {
			.patientInfo,
			.doctorReport,
			.doctorGrade {
				transition: all 0.3s ease;
				
				// 确保内容在宽度变化时能够正常显示
				> div {
					width: 100%;
					overflow: hidden;
				}
			}
			
			// 折叠时的特殊样式
			.patientInfo {
				&.el-col-2 {
					// 当折叠时，确保内容不会溢出
					overflow: hidden;
					
					> div {
						// width: 96px;
						min-width: 96px;
					}
				}
			}
			
			// 展开时的样式
			.doctorReport,
			.doctorGrade {
				&.el-col-11 {
					// 当其他组件折叠时，确保内容能够充分利用空间
					> div {
						width: 100%;
					}
				}
			}
		}
	}
}
</style>